import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Races
export const getRaces = async (params = {}) => {
  const response = await api.get('/races', { params });
  return response.data;
};

export const getRace = async (id) => {
  const response = await api.get(`/races/${id}`);
  return response.data;
};

export const createRace = async (data) => {
  const response = await api.post('/races', data);
  return response.data;
};

export const updateRace = async (id, data) => {
  const response = await api.put(`/races/${id}`, data);
  return response.data;
};

export const deleteRace = async (id) => {
  const response = await api.delete(`/races/${id}`);
  return response.data;
};

export const importCSV = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/races/import-csv', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const seedRaces = async () => {
  const response = await api.post('/races/seed');
  return response.data;
};

export const getStats = async () => {
  const response = await api.get('/races/stats/summary');
  return response.data;
};

// Districts and race types
export const getDistricts = async () => {
  const response = await api.get('/districts');
  return response.data.districts;
};

export const getRaceTypes = async () => {
  const response = await api.get('/race-types');
  return response.data.types;
};

// Submissions
export const createSubmission = async (data) => {
  const response = await api.post('/submissions', data);
  return response.data;
};

export const getSubmissions = async (status = null) => {
  const params = status ? { status } : {};
  const response = await api.get('/submissions', { params });
  return response.data;
};

export const approveSubmission = async (id, force = false) => {
  const response = await api.post(`/submissions/${id}/approve`, null, {
    params: { force }
  });
  return response.data;
};

export const rejectSubmission = async (id) => {
  const response = await api.post(`/submissions/${id}/reject`);
  return response.data;
};

export const updateSubmission = async (id, data) => {
  const response = await api.put(`/submissions/${id}`, data);
  return response.data;
};

export const deleteSubmission = async (id) => {
  const response = await api.delete(`/submissions/${id}`);
  return response.data;
};

export const getSubmissionsStats = async () => {
  const response = await api.get('/submissions/stats/summary');
  return response.data;
};

export default api;
